import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import _ from 'lodash';
import { DatePipe } from '@angular/common';

import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { CollaboratorService } from './../../../rest/api/collaborator.service';

@Component({
  selector: 'app-space-list',
  templateUrl: './space-list.component.html',
  styleUrls: ['./space-list.component.scss'],
  providers: [DatePipe]
})
export class SpaceListComponent implements OnInit {
  @Input() spaceListData;
  @Input() spaceLoader;
  @Input() itemsPerPage;
  @Input() currentPage;
  @Input() totalCount;

  @Output() pageChangedEmit = new EventEmitter();
  @Output() updateMemberSpaceEmit = new EventEmitter();
  @Output() deleteMemberSpaceEmit = new EventEmitter();
  @Output() spaceInviteCollaboratorEmit = new EventEmitter();

  singleSpaceData: any;

  accessToken: any;
  deleteSpaceError: any;
  deleteSpaceSuccess: any;

  deleteFreeSpaceMessage: any;

  collaboratorsData: any;
  activeCollaborators: any;
  filteredCollaboratorData: any;
  selectedCollaborator: any;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    private datePipe: DatePipe,
    public collaboratorService: CollaboratorService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.getCollaborators();
  }

  pageChanged(event) {
    this.currentPage = event;
    this.pageChangedEmit.emit(event);
  }

  updateSpace(space) {
    this.singleSpaceData = space;
  }

  closeUpdateSpaceEmit(response) {
    this.singleSpaceData = undefined;
    // if ($('#updateSpace')) {
    //   $('#updateSpace').modal('hide');
    // }
  }

  updateSpaceEmit(response) {
    if ($('#updateSpace')) {
      $('#updateSpace').modal('hide');
    }
    this.singleSpaceData = undefined;
    this.pageChangedEmit.emit(this.currentPage);
  }

  deleteSpace(space) {
    this.deleteFreeSpaceMessage = undefined;
    this.singleSpaceData = space;
  }

  modalCloseEmit() {
    if (document.getElementById('modalClose')) {
      document.getElementById('modalClose').click();
    }
    this.deleteMemberSpaceEmit.emit(true);
    // this.deleteSpaceSuccess = undefined;
  }

  inviteCollaboratorSpace(space) {
    this.singleSpaceData = space;
  }

  spaceInviteCollaborator(response) {
    if (('.modal')) {
      $('.modal').modal('hide');
    }
    this.singleSpaceData = undefined;
    this.spaceInviteCollaboratorEmit.emit(response);
  }

  convertDate(value) {
    try {
      return this.datePipe.transform(value, 'yyy-MM-dd');
    } catch {
      return undefined;
    }
  }

  deleteFreeSpace(value) {
    this.deleteFreeSpaceMessage = 'Free space cannot be deleted';
    // setTimeout(() => {
    //   this.singleSpaceData = undefined;
    //   this.deleteFreeSpaceMessage = undefined;
    // }, 3000);
  }

  closeDeleteFreeSpaceBtn() {
    this.deleteFreeSpaceMessage = undefined;
  }

  getCollaborators() {
    this.collaboratorService.getCollaboratorList(this.accessToken).subscribe((response: any) => {
      this.collaboratorsData = response && response.data ? response.data : [];
      this.filteredCollaboratorData = _.filter(this.collaboratorsData, {status: 'active' , role: 'user'});
    }, err => {
      this.collaboratorsData = [];
      this.filteredCollaboratorData = [];
    });
  }

}
